import { Maybe } from 'graphql/jsutils/Maybe'
import { FC } from 'react'

import { Office } from '../../../../generated'
import OfficeDropdown from '../../common/OfficeDropdown'

interface LocationFilterProps {
  locationName: any
  setReportFilters: any
}

const LocationFilter: FC<LocationFilterProps> = ({ locationName, setReportFilters }) => {
  const handleLocationChange = (value: Maybe<Office>) => {
    setReportFilters((prev: any) => ({ ...prev, location: value?.name }))
  }

  return (
    <OfficeDropdown
      selectedOffice={locationName}
      sx={{ minWidth: 200 }}
      label="Location"
      onChange={handleLocationChange}
      isProfitCenter={false}
    />
  )
}

export default LocationFilter
